import axiosNeuron from "api/axios";
import endpoints from "api/endpoints";

type TParams = {
  name: string;
  search_events?: boolean;
  search_labels?: boolean;
  ids?: number[] | null;
  machine?: number[] | null;
  placement?: number[] | null;
  from?: string | null;
  to?: string | null;
  eventType?: number[] | null;
  machineSubcategory?: number[] | null;
  placementType?: number[] | null;
  failureType?: number[] | null;
  q?: string | null;
  labelSubcategory?: number[] | null;
  value_min?: number | null;
  value_max?: number | null;
};

export default async function addFromSound({
  name,
  search_events,
  search_labels,
  ids,
  machine,
  placement,
  from,
  to,
  eventType,
  machineSubcategory,
  placementType,
  failureType,
  q,
  labelSubcategory,
  value_min,
  value_max,
}: TParams) {
  const url = endpoints.similaritySearchService.fromSounds;

  const params = {
    name: name,
    search_events: search_events,
    search_labels: search_labels,
  };
  const idsFilter = ids ? `&id=${ids.join("&id=")}` : "";
  const machineFilter = machine ? `&machine=${machine.join("&machine=")}` : "";
  const placementFilter = placement
    ? `&placement=${placement.join("&placement=")}`
    : "";
  const eventTypeFilter = eventType
    ? `&event_type=${eventType.join("&event_type=")}`
    : "";
  const machineSubcategoryFilter = machineSubcategory
    ? `&machine_subcategory=${machineSubcategory.join("&machine_subcategory=")}`
    : "";
  const placementTypeFilter = placementType
    ? `&placement_type=${placementType.join("&placement_type=")}`
    : "";
  const failureTypeFilter = failureType
    ? `&failure_type=${failureType.join("&failure_type=")}`
    : "";
  const labelSubcategoryFIlter = labelSubcategory
    ? `&label_subcategory=${labelSubcategory.join("&label_subcategory=")}`
    : "";
  const start = from ? `start${new Date(from).toISOString()}` : "";
  const end = to ? `end${new Date(to).toISOString()}` : "";
  const qFilter = q ? `q=${q}` : "";
  const valueMinFilter = value_min ? `&value_min=${value_min}` : "";
  const valueMaxFilter = value_max ? `&value_max=${value_max}` : "";

  const fullUrl = `${url}?${idsFilter}${machineFilter}${placementFilter}${eventTypeFilter}${machineSubcategoryFilter}${placementTypeFilter}${failureTypeFilter}${labelSubcategoryFIlter}${start}${end}${qFilter}${valueMinFilter}${valueMaxFilter}`;
  try {
    const { data } = await axiosNeuron.post(fullUrl, params);
    return data;
  } catch (error) {
    if (error !== undefined) {
      throw error;
    }
  }
}
